export default function HomePage() {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Agent Web App
                </h1>
                <p className="text-gray-600 mb-8">
                    Bem-vindo ao sistema de gerenciamento de agentes
                </p>
                <a
                    href="/agentes"
                    className="inline-flex items-center justify-center h-12 px-6 text-base font-medium bg-blue-600 text-white hover:bg-blue-700 rounded-md transition-colors"
                >
                    Ver Agentes
                </a>
            </div>
        </div>
    )
}
